<template>
  <section id="home">
    <v-img
      :min-height="minHeight"
      :src="require('@/assets/home.jpg')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
    >
      <v-container
        v-intersect.quiet="{
          handler: onIntersect,
          options: {
            threshold: [0.5]
          }
        }"
        class="fill-height px-4 py-12"
      >
        <v-responsive
          class="d-flex align-center"
          height="100%"
          width="100%"
        >
          <div
            class="hidden-sm-and-down text-center"
          >
            <img
              style="max-width: 200px; margin-right: 10px;"
              :src="require('@/assets/logo.png')"
            >
          </div>

          <base-heading
            class="text-center"
            title="SOFTWARE ENGINEERING"
          />

          <base-body class="text-center">
            <b class="primary--text">Join us on this journey. <br v-if="$vuetify.breakpoint.smAndDown"></b> We ensure<b> commitment, agility, </b>and<b> innovation.</b>
          </base-body>
          <div class="text-center">
            <v-btn
              fab
              outlined
              @click="$vuetify.goTo('#services')"
            >
              <v-icon>mdi-chevron-double-down</v-icon>
            </v-btn>
          </div>
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>

<script>
  import { eventBus } from '../../main'

  export default {
    name: 'SectionHero',

    provide: {
      theme: { isDark: true },
    },

    computed: {
      minHeight () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '100vh'

        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },
    },
    methods: {
      onIntersect (entries, observer) {
        if (entries[0].intersectionRatio >= 0.5) {
          eventBus.$emit('selectTab', 'home')
        }
      },
    },
  }
</script>
